import React from 'react'
import PropTypes from 'prop-types'
import { CardInnerHeading } from '../../../../shared/settings/card'

import addIcon from '../../../../../../images/add-to-list.svg'
import renderIconButton from '../../../../shared/settings/render-icon-button'
import styles from '../recurring-voucher/recurring-vouchers.css'

const AddVoucher = ({ handleIveGotAVoucher }) => {
  const addVoucherIconButton = renderIconButton(
    handleIveGotAVoucher,
    'addVoucher',
    styles.iconButton,
    'Add Voucher',
    addIcon
  )
  return (
    <>
      <CardInnerHeading
        header="Got a voucher?"
        className={styles.innerHeader}
      />
      {addVoucherIconButton}
    </>
  )
}

AddVoucher.propTypes = {
  handleIveGotAVoucher: PropTypes.func.isRequired
}

export default AddVoucher
